<template>
  <v-container fluid class="footer">
    <icon-base icon-name="truetzschler" width="115" height="25" viewBox="0 0 115 25">
      <icon-truetzschler fill="#B7B7B7" />
    </icon-base>
    <div class="version-number">Version: {{ buildNumber }}</div>
  </v-container>
</template>
<script>
import IconBase from '@/components/icons/IconBase';
import IconTruetzschler from '@/components/icons/IconTruetzschler';
import build from '@/assets/build-number.json';

export default {
  components: {
    IconBase,
    IconTruetzschler
  },
  computed: {
    buildNumber() {
      return build.buildNumber;
    }
  }
};
</script>

<style lang="scss" scoped>
.version-number {
  position: absolute;
  font-size: 10px;
  bottom: 5px;
  color: var(--v-lightBlueGrey-base);
}
</style>
